module.exports = __webpack_public_path__ + "static/media/team-member-01.9f08c14a.jpg";